module.exports = __webpack_public_path__ + "static/Fintech Logo.01ae4efd.svg";